import MenuItem from "@mui/material/MenuItem";
import { FormControl, OutlinedInput, Select, Typography } from "@mui/material";
import React from "react";
import i18n from "../i18n-config";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

interface CustomDropdownProps {
  items?: any[];
  containerStyle?: React.CSSProperties;
  selectStyle?: React.CSSProperties;
  itemStyle?: React.CSSProperties;
  titleStyle?: React.CSSProperties;
  placeholderStyle?: React.CSSProperties;
  title: string;
  placeholder?: string | null;
  value?: any;
  handleChange: (ev: string) => void;
  isDynamic?: boolean;
  size?: "small" | "medium";
}

const CustomDropdown: React.FC<CustomDropdownProps> = ({
  items = [],
  title,
  containerStyle,
  value,
  selectStyle,
  titleStyle,
  handleChange,
  isDynamic,
  placeholder,
  placeholderStyle,
  size
}) => {
  return (
    <FormControl sx={{ marginTop: 3, titleStyle, ...containerStyle }} fullWidth>
      <Typography
        color="black"
        sx={{
          fontSize: {
            xs: 12,
            md: 14,
          },
          mb: 1,
          ...titleStyle,
        }}
      >
        {title}
      </Typography>
      {!value ? (
        <Typography
          sx={{
            position: "absolute",
            zIndex: 9999,
            left: 10,
            ...placeholderStyle,
          }}
          color="white"
        >
          {placeholder}
        </Typography>
      ) : null}
      <Select
        disableUnderline
        variant="standard"
        value={value}
        size={size}
        onChange={(val: any) => handleChange(val.target.value)}
        input={<OutlinedInput />}
        style={{
          backgroundColor: "#fff",
          ...selectStyle,
        }}
        MenuProps={MenuProps}
        displayEmpty
      >
        {isDynamic
          ? items.map((service) => (
              <MenuItem key={service.id} value={service.id}>
                {service.libelle}
              </MenuItem>
            ))
          : items.map((service) => (
              <MenuItem key={service} value={service}>
                {i18n.t(service)}
              </MenuItem>
            ))}
      </Select>
    </FormControl>
  );
};

export default CustomDropdown;
